import React from "react";
import { Map, fromJS } from 'immutable';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';

import Widget from "components/Widget/index";
import { albama, allProperties, colorado, newJercy } from "app/routes/dashboard/routes/Listing/data"
import { connect } from 'react-redux';
import firebase from "firebase";

import PropertiesItemCard from './PropertiesItemCard'

import {
  saveFolderID,
} from 'actions/MyFolders';

import {
  saveProjectID, loadProjects
} from 'actions/MyProjects';

class AccessRecord {
  constructor(name, day, version,hour) {
    this.name = name;
    this.day = day;
    this.version = version;
    this.hour = hour;
  }
}


const propertiesData = [allProperties, newJercy, colorado, albama];

class Project {
  constructor(key, customer, endDate, generalContractor, myRole, name, note, startDate) {
    this.key = key;
    this.customer = customer;
    this.endDate = endDate;
    this.generalContractor = generalContractor;
    this.myRole = myRole;
    this.note = note;
    this.startDate = startDate;
    this.name = name;

  }
}



class ProjectCard extends React.Component {

  state = {
    activeTab: '1',
    loader: false,
  };

  componentDidMount() {

    const userID = localStorage.getItem('user_id');
   // this.props.loadProjects(userID);
  }

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({
      properties: propertiesData[value],
      loader: true
    });
    setTimeout(() => {
      this.setState({ loader: false });
    }, 1500);
  };

  render() {

    if (this.props.myProjectList) {

      console.log("********************SCRIVO SU ACCESS");

      var userID= localStorage.getItem('user_id');
      var date = new Date().getDate(); //Current Date
      var day = new Date().getDate();
    var month = new Date().getMonth() + 1; //Current Month
    var year = new Date().getFullYear(); //Current Year
    var hours = new Date().getHours(); //Current Hours
    var min = new Date().getMinutes(); //Current Minutes
    var sec = new Date().getSeconds(); //Current Seconds

    var finalDate= ""+day+"/"+month+"/"+year;
    var finalHour= ""+hours+":"+min+":"+sec;
      var version="web_panel";
      var myRecord= new AccessRecord("",finalDate,version, finalHour);

      firebase.database().ref('/access/' + userID )
      .push(myRecord).then((data) => {
          //success callback
      }).catch((error) => {
          //error callback
          console.log('error ', error)
      });


      var data_list = [];
      this.props.myProjectList.forEach(function (childSnapshot) {
        var key = childSnapshot.key;
        console.log("#######sono la key " + key);

        var customer = childSnapshot.val().customer;
        var endDate = childSnapshot.val().endDate;
        var generalContractor = childSnapshot.val().generalContractor;
        var myRole = childSnapshot.val().myRole;
        var name = childSnapshot.val().name;
        var note = childSnapshot.val().note;
        var startDate = childSnapshot.val().startDate;

        var project = new Project(key, customer, endDate, generalContractor, myRole, name, note, startDate);

        data_list.push(project);
      });


      return (
        <Widget >
          <div className="d-flex flex-row justify-content-between mb-2" >
            <h4 className="mr-2">I miei progetti</h4>

            <span className="ml-2 pointer"><i className="zmdi zmdi-search text-primary jr-fs-xl" /></span>
          </div>
          <div className="jr-news-action jr-tabs-classic jr-tabs-classic-no-border">
            <div className="jr-tabs-up jr-tabs-up-no-border">
            </div>

            <TabContent className="jr-tabs-content" activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                {data_list.map((data, index) =>

                  <PropertiesItemCard index={index} data={data} props={this.props} />

                )}
              </TabPane>


            </TabContent>
          </div>
        </Widget>
      );
    }
    else {

     

      return (
        <div
          style={{
            position: 'absolute', left: '50%', top: '50%',
            transform: 'translate(-50%, -50%)'
          }}
        >NON CI SONO PROGETTI</div>
      )
    }
  }
}

const mapStateToProps = ({ myProjects }) => {
  const { myProjectList } = myProjects;
  return { myProjectList }
};

export default connect(mapStateToProps, {
  saveFolderID, saveProjectID, loadProjects
})(ProjectCard);

